// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GameProgressBar__root--lMG3R {
    margin-bottom: 20px;
}

    @media screen and (min-width: 1024px) {.GameProgressBar__root--lMG3R {
        padding: 0 24px
}
    }

.GameProgressBar__title--WARpn {
    color: var(--dark-fourth-new-color);
    text-align: center;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

@media screen and (min-width: 1024px) {

.GameProgressBar__title--WARpn {
        font-size: 20px;
        line-height: 28px
}
    }

.GameProgressBar__progressBar--EhvkJ {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 8px;
}

.GameProgressBar__wrapper--__VIF {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.GameProgressBar__progressBarThumb--xEkhW {
    width: 100%;
    border-radius: 30px;
    border: 1px solid #313337;
    background-color: #1E2028;
    height: 12px;
    overflow: hidden;
    padding: 1px;
}

.GameProgressBar__progressBarActive--OoUq6 {
    transition: width 0.25s ease-in-out;
    background: linear-gradient(90deg, #FFA300 0%, #FF5B00 174.43%);
    height: 100%;
    border-radius: 91px;
}

.GameProgressBar__information--l4JfS {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
}

.GameProgressBar__count--Hrjrz {
    color:rgba(255, 255, 255, 0.6);
    font-size: 8px;
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;
}

@media screen and (min-width: 1024px) {

.GameProgressBar__count--Hrjrz {
        font-size: 12px
}
    }

.GameProgressBar__image--u0_Fk {
    width: 42px;
    height: 42px;
}`, "",{"version":3,"sources":["webpack://./src/components/Plelander/GameProgressBar/GameProgressBar.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AAKvB;;IAHI,uCAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AAMtB;;AAJI;;AATJ;QAUQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,+DAA+D;IAC/D,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAK7B;;AAHI;;AAPJ;QAQQ;AAER;IADI;;AAGJ;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".root {\n    margin-bottom: 20px;\n\n    @media (--large) {\n        padding: 0 24px;\n    }\n}\n\n.title {\n    color: var(--dark-fourth-new-color);\n    text-align: center;\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 20px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n\n    @media (--large) {\n        font-size: 20px;\n        line-height: 28px;\n    }\n}\n\n.progressBar {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-gap: 8px;\n}\n\n.wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.progressBarThumb {\n    width: 100%;\n    border-radius: 30px;\n    border: 1px solid #313337;\n    background-color: #1E2028;\n    height: 12px;\n    overflow: hidden;\n    padding: 1px;\n}\n\n.progressBarActive {\n    transition: width 0.25s ease-in-out;\n    background: linear-gradient(90deg, #FFA300 0%, #FF5B00 174.43%);\n    height: 100%;\n    border-radius: 91px;\n}\n\n.information {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 2px;\n}\n\n.count {\n    color:rgba(255, 255, 255, 0.6);\n    font-size: 8px;\n    font-weight: 700;\n    line-height: 20px;\n    text-transform: uppercase;\n\n    @media (--large) {\n        font-size: 12px;\n    }\n}\n\n.image {\n    width: 42px;\n    height: 42px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `GameProgressBar__root--lMG3R`,
	"title": `GameProgressBar__title--WARpn`,
	"progressBar": `GameProgressBar__progressBar--EhvkJ`,
	"wrapper": `GameProgressBar__wrapper--__VIF`,
	"progressBarThumb": `GameProgressBar__progressBarThumb--xEkhW`,
	"progressBarActive": `GameProgressBar__progressBarActive--OoUq6`,
	"information": `GameProgressBar__information--l4JfS`,
	"count": `GameProgressBar__count--Hrjrz`,
	"image": `GameProgressBar__image--u0_Fk`
};
export default ___CSS_LOADER_EXPORT___;
